
function form_submit(fm) {
    var m_name = "";
    var m_age = "";
    var m_tel1 = "";
    var m_tel2 = "";
    var m_tel3 = "";
    var m_tel = "";

    if (fm.username) {
        m_name = fm.username.value;
    }

    if (fm.age) {
        m_age = fm.age.value;
    }

    if (fm.tel1) {
        m_tel1 = fm.tel1.value;
    }

    if (fm.tel2) {
        m_tel2 = fm.tel2.value;
    }

    if (fm.tel3) {
        m_tel3 = fm.tel3.value;
    }

    if (fm.tel1 && fm.tel2 && fm.tel3) {
        m_tel = m_tel1 + m_tel2 + m_tel3;
    }

	if ( m_name == "" ) { alert( "이름을  입력해주십시요."); fm.username.focus(); return false; }
	if ( m_age == "" ) { alert( "나이를 입력해주십시요."); fm.age.focus(); return false; }
	if( m_tel1 == "010" ) {
		if ( m_tel2.length != 4 ) { alert( "연락처를 4자리로 입력해주십시요."); fm.tel2.focus();return false; }
	} else {
		if ( m_tel2.length < 3 ) { alert( "연락처를 3자리 이상 입력해주십시요."); fm.tel2.focus();return false; }
	}
	if ( m_tel3 == "" || m_tel3.length != 4 ) { alert( "연락처를 4자리로 입력해주십시요."); fm.tel3.focus();return false; }
    if (fm.inforAgree) {
        if ( fm.inforAgree.checked === false ) { alert("이벤트정보 수신에 동의해 주십시오.");	return false;	}
    }
	if (fm.inforAgree2) {
        if ( fm.inforAgree2.checked === false ) { alert("개인정보 취급 방침에 동의해 주십시오.");	return false;	}
    }
	
    var real_data = $(fm).serialize();
    $.ajax({
		url : "./event.php",
		type : "post",
		data :  real_data,
		success : function(data) {
			if (data == "true") {
				location.href = "success.html";
			} else {
				alert(data);
			}
		}
	});

}

$(".num_check").on("blur", function(){
    var num = $(this).val();
    if(isNaN(num)) alert("숫자만 입력가능합니다. ");
})

window.form_submit = form_submit;